import avatar from '../../img/profile-def.svg';

export const messagesData = [
  {
    id: 1,
    author: 'John Doe',
    time: '1:15PM',
    subject: 'kjsdfkjfsdjkfdskjfsdkhj',
    content: 'fsdgsfdgsfdgfsgdsfdgfgd',
    avatar: avatar,
    selected: true,
  },
  {
    id: 2,
    author: 'Sarah Connor',
    time: '11:35AM',
    subject: 'kjsdfkjfsdjkfdskjfsdkhj',
    content: 'fsdgsfdgsfdgfsgdsfdgfgd',
    avatar: avatar,
    selected: false,
  },
  {
    id: 3,
    author: 'Michael Smith',
    time: '9:10AM',
    subject: 'kjsdfkjfsdjkfdskjfsdkhj',
    content: 'fsdgsfdgsfdgfsgdsfdgfgd',
    avatar: avatar,
    selected: false,
  },
  {
    id: 4,
    author: 'Marta Doe',
    time: 'May 25',
    subject: 'kjsdfkjfsdjkfdskjfsdkhj',
    content: 'fsdgsfdgsfdgfsgdsfdgfgd',
    avatar: avatar,
    selected: false,
  },
  {
    id: 5,
    author: 'Jessica Dore',
    time: 'May 3',
    subject: 'kjsdfkjfsdjkfdskjfsdkhj',
    content: 'fsdgsfdgsfdgfsgdsfdgfgd',
    avatar: avatar,
    selected: false,
  },
  {
    id: 6,
    author: 'Mellisa Smith',
    time: 'Apr 27',
    subject: 'kjsdfkjfsdjkfdskjfsdkhj',
    content: 'fsdgsfdgsfdgfsgdsfdgfgd',
    avatar: avatar,
    selected: false,
  },
  {
    id: 7,
    author: 'Andy Woods',
    time: 'Mar 3',
    subject: 'kjsdfkjfsdjkfdskjfsdkhj',
    content: 'fsdgsfdgsfdgfsgdsfdgfgd',
    avatar: avatar,
    selected: false,
  },
  {
    id: 8,
    author: 'Mohamed Singh',
    time: 'Feb 20',
    subject: 'kjsdfkjfsdjkfdskjfsdkhj',
    content: 'fsdgsfdgsfdgfsgdsfdgfgd',
    avatar: avatar,
    selected: false,
  },
  {
    id: 9,
    author: 'Mathew S.',
    time: 'Feb 15',
    subject: 'kjsdfkjfsdjkfdskjfsdkhj',
    content: 'fsdgsfdgsfdgfsgdsfdgfgd',
    avatar: avatar,
    selected: false,
  },
  {
    id: 10,
    author: 'Ana Vera',
    time: 'Feb 10',
    subject: 'kjsdfkjfsdjkfdskjfsdkhj',
    content: 'fsdgsfdgsfdgfsgdsfdgfgd',
    avatar: avatar,
    selected: false,
  },
];
